"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationLiveViewIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var NotificationLiveViewIcon = function NotificationLiveViewIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.909091",
    y: "5.33292",
    width: "16.6431",
    height: "10.4893",
    rx: "4.54545",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "1.81818"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6.15434",
    cy: "10.5772",
    r: "1.39857",
    stroke: "#DF434D",
    strokeWidth: "1.81818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 6.73118C19.0909 7.92841 18.1203 8.89897 16.9231 8.89897C15.7258 8.89897 14.7553 7.92841 14.7553 6.73118C14.7553 5.53394 15.7258 4.56339 16.9231 4.56339C18.1203 4.56339 19.0909 5.53394 19.0909 6.73118Z",
    fill: "#DF434D",
    stroke: "white",
    strokeWidth: "1.81818"
  })));
};
exports.NotificationLiveViewIcon = NotificationLiveViewIcon;